import { useSelector } from 'react-redux';
import {
	getRequestComment,
	getRequestCreateDate,
	getRequestDocuments,
	getRequestId,
	getRequestStatus,
	getRequestTimeLimit
} from '../model';
import { useRequestBreadcrumbs } from './useRequestBreadcrumbs';

export const useRequestStatus = () => {
	const breadcrumbs = useRequestBreadcrumbs();

	const requestId = useSelector(getRequestId);
	const status = useSelector(getRequestStatus);
	const comment = useSelector(getRequestComment);
	const timeLimit = useSelector(getRequestTimeLimit);
	const documents = useSelector(getRequestDocuments);
	const createDate = useSelector(getRequestCreateDate);

	return {
		status,
		comment,
		documents,
		requestId,
		timeLimit,
		createDate,
		breadcrumbs,
		ns: 'Refund'
	};
};
